"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEvent = void 0;
var index_1 = require("./index");
function createEvent(eventName, context) {
    // This is what fill's in the basic event details.
    var flesher = index_1.getFlesher();
    if (!flesher)
        throw new Error("Need event flesher to create events");
    return context === undefined
        ? __assign(__assign({}, flesher()), { event_name: eventName }) : __assign(__assign(__assign({}, flesher()), { event_name: eventName }), context);
}
exports.createEvent = createEvent;
